export default __webpack_public_path__ + "static/media/ida-message.1014d76e.png";